export default {
  name: 'Header',

  props: {
    title: String,
    options: [Array, Number],
    isAdditionalField: String,
    isSearcheble: Boolean,
    required: Boolean,
    disabled: Boolean,
    defaultOption: Number,
    defaultValue: String,
    disableErrors: Boolean,
    size: String,
    simple: Boolean,
    placeholder: String,
    clearAfterBlur: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onSelect(option) {
      this.isError = false;
      this.$emit('onSelect', option);
      this.$emit('input', option);
      this.input = option.name ? option.name : option;
      this.isShowDropdown = false;
      this.isSelected = true;
      this.tempInput = null;
    },

    onFocus() {
      this.tempInput = this.input;
      this.input = null;
    },

    onChange() {
      this.isError = false;
      this.isSelected = false;
      this.$emit('onSearch', this.input);
      this.isShowDropdown = true;
      this.tempInput = null;
    },

    onFormClick() {
      if (this.disabled) {
        this.isShowDropdown = false;
        return;
      }

      this.isShowDropdown = !this.isShowDropdown;
    },

    hideDropdown() {
      setTimeout(() => {
        if (document.activeElement.className === 'dropdown') {
          return;
        }

        this.isShowDropdown = false;

        if (!this.input && this.tempInput) {
          this.input = this.tempInput;
          this.tempInput = null;
        }

        if (!this.isSelected && this.clearAfterBlur) {
          this.input = null;
          this.tempInput = null;
        }
      }, 200);
    },

    clear() {
      this.isSelected = false;
      this.input = null;
      this.tempInput = null;
    },


    validate() {
      if (this.required && !this.isSelected) {
        this.isError = true;
      }

      return this.required ? this.isSelected : true;
    },
  },

  created() {
    if (this.defaultOption !== undefined) {
      this.input = this.options[this.defaultOption].name;
      this.isSelected = true;
    }
    if (this.defaultValue) {
      this.input = this.defaultValue;
    }
  },

  data() {
    return {
      input: null,
      locale: this.$i18n.locale,
      isShowDropdown: false,
      isSelected: false,
      isError: false,
      tempInput: null,
    };
  },
};
